var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSuccessful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9997 0.332031C18.9997 0.332031 0.333008 18.9987 0.333008 41.9987C0.333008 64.9987 18.9997 83.6654 41.9997 83.6654C64.9997 83.6654 83.6664 64.9987 83.6664 41.9987C83.6664 18.9987 64.9997 0.332031 41.9997 0.332031ZM33.6663 62.832L12.833 41.9987L18.708 36.1237L33.6663 51.0404L65.2913 19.4154L71.1663 25.332L33.6663 62.832Z",
    fill: "#eb672d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccessful);
export default __webpack_public_path__ + "static/media/IconSuccessful.575252eb34fa8fcf02ce8cc96f05d847.svg";
export { ForwardRef as ReactComponent };